import axiosInstance from "../lib/axiosInstance";



const authModel = class {

    async login(data = []) {
        return await axiosInstance.post(process.env.REACT_APP_API_URL+"/auth/send_otp", data);
    }
    async VerifyOtp(data = []) {
        return await axiosInstance.post(process.env.REACT_APP_API_URL+"/auth/verify_otp", data);
    }
}

export default new authModel();
